import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import REQUIRED_FIELDS from '../../offers/REQUIRED_FIELDS';
import ChartLoader from '../../dashboard/_charts/ChartLoader';
import DonutChart from '../../dashboard/_charts/DonutChart';
import colors from 'tailwindcss/colors';

export default function OfferResponseYear(props) {
  const { network, schoolStart, schoolEnd, subtitle } = props;

  const responses = [
    'Connected',
    'Pending',
    'Declined',
    'No invites'
  ];

  const responseMap = {
    'No invites': {
      numberOfClaimsPending: 0,
      numberOfClaimsConnect: 0,
      numberOfClaimsDecline: 0
    },
    'Pending': {
      numberOfClaimsPending: {
        $gte: 1
      },
      numberOfClaimsConnect: 0,
      // numberOfClaimsDecline: 0
    },
    'Connected': {
      // numberOfClaimsPending: 0,
      numberOfClaimsConnect: {
        $gte: 1
      },
      // numberOfClaimsDecline: 0
    },
    'Declined': {
      numberOfClaimsPending: 0,
      numberOfClaimsConnect: 0,
      numberOfClaimsDecline: {
        $gte: 1
      }
    }
  };

  const requests = responses.map(function(response) {
    return {
      label: response,
      offers: useConnect('offer.find', {
        where: {
          eager: {
            $aggregations: [
              'Pending',
              'Connect',
              'Decline'
            ].map(function(response) {
              return {
                type: 'count',
                alias: `numberOfClaims${response}`,
                relation: 'claims',
                $where: {
                  response: response
                }
              };
            }),
            $where: {
              $and: REQUIRED_FIELDS.$and,
              activityId: {
                $null: false
              },
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            },
            $having: {
              ...responseMap[response]
            }
          }
        },
        pagination: {
          pageSize: 1
        }
      })
    };
  });

  const loading = _.reduce(requests, function(result, request) {
    return result || request.offers.state === PayloadStates.FETCHING;
  }, false)

  if (loading) {
    return (
      <ChartLoader
        title="Offers by Educator Status"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const series = requests.map(r => r.offers.meta.totalCount);
  const labels = requests.map(r => r.label);

  return (
    <DonutChart
      title="Offers by Educator Status"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.yellow['400'],
        colors.red['400'],
        colors.blue['400']
      ]}
    />
  );
}
